export default __webpack_public_path__ + "static/media/KOD0111-min.6ae7aa9d.webp";